import { useQuery } from "@apollo/client"
import { Link, useParams } from "react-router-dom"
import { gql } from "~/__generated__"
import { GraphqlError } from "~/ui/errors"
import { useDocumentTitle } from "~/common/use-document-title"
import { ScreenLoading } from "~/ui/screen-loading"
import { columns } from "./columns"
import { DataTable } from "~/admin/data-table"
import { myLettermemeManagePath } from "~/common/paths"

const sourcesQuery = gql(/* GraphQL */ `
  query Sources($lettermemeId: ID!) {
    sources(lettermemeId: $lettermemeId, onlyNewsletters: true) {
      id
      email
      url
      lastNewsletterAt
      active
      newsletterInputsCount
    }
  }
`)

export const SourcesScreen: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const { data, error, loading } = useQuery(sourcesQuery, {
    variables: { lettermemeId: id! },
    skip: !id,
  })

  useDocumentTitle("Sources")

  if (error) return <GraphqlError error={error} />
  if (loading) return <ScreenLoading />

  const sources = data?.sources ?? []

  return (
    <div className="mx-auto max-w-7xl p-8">
      <div className="mb-8">
        <Link to={myLettermemeManagePath({ id: id! })} className="text-gray-400">
          ← back to lettermeme settings
        </Link>
        <h1 className="mt-4 text-2xl font-bold">Sources</h1>
        <p className="text-gray-400">Newsletter sources for this lettermeme</p>
      </div>
      <DataTable columns={columns} data={sources} />
    </div>
  )
}
